import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';

@Component({
  selector: 'app-plan-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './plan-card.component.html',
  styleUrls: ['./plan-card.component.scss' , '../../../../../styles/admin/style.scss','../../../../../styles/admin/app.scss']
})
export class PlanCardComponent  extends FormValidation implements OnInit{

  @Input() cards : Array<any> = [];
  @Input() TOTAL : number;
  @Input() isJobs : boolean = false;
  @Input() columns: number; // Default to 3 columns 
  cardSize = 'col-xl-4 col-sm-4';

  constructor(){
    super();
  }

  ngOnInit(): void {
 if (this.isJobs) {
    const plan = localStorage.getItem('MemberShipType');
    this.cardSize = plan === GigsumoConstants.FREE_PLAN ? 'col-sm-3' : 'col-sm-2';
  } else {
    // Set default based on columns
    this.cardSize = this.columns === 5 ? 'col-sm-2' : 'col-sm-4';
  }
  } 

}
